import axiosInstance from "./axiosInstance";

import { API_V2 } from "@Models/GWDomain";

export const baseUrl = `${API_V2}/pos`;
export const appointmentsBaseUrl = `${API_V2}/reservations`;
export const loungesBaseUrl = `${API_V2}/locals`;
export const employeesBaseUrl = `${API_V2}/employees`;
export const servicesBaseUrl = `${API_V2}/services`;
export const clientsBaseUrl = `${API_V2}/customers`;
export const warehousesBaseUrl = `${API_V2}/products`;
export const marketingBaseUrl = `${API_V2}/marketing`;
export const accountBaseUrl = `${API_V2}/account`;

/**
 * @deprecated No usar directamente. El token ahora se obtiene dinamicamente via interceptor.
 * Mantenido solo por compatibilidad con codigo legacy que pueda importarlo.
 */
const tokenLocal = localStorage.getItem("access_token");

/**
 * @deprecated No usar directamente. El header de autorizacion ahora se agrega
 * automaticamente via interceptor en cada request.
 * Usar axiosInstance en lugar de axios con este config.
 */
export const config = {
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${tokenLocal}`,
  },
};

// Exportar la instancia de axios configurada para uso directo
export { axiosInstance };
